import React from "react"
import styled from "styled-components"
import { Swiper, SwiperSlide } from "swiper/react"
import { theme } from "./mixin"
import "swiper/css"
import { Autoplay } from "swiper/modules"
// import "swiper/css/pagination"

import RewardCard from "./RewardCard"

export default function SliderSection({ data }) {
  return (
    <Wrapper>
      <Swiper
        slidesPerView={"auto"}
        centeredSlides={true}
        spaceBetween={80}
        modules={[Autoplay]}
        className="mySwiper"
        initialSlide={0}
        loop={true}
        autoplay={{
          delay: 0,
          disableOnInteraction: false
        }}
        speed={5000}
      >
        {data.map(({ img, title, discount }) => (
          <SwiperSlide key={title}>
            <CardWrapper>
              <RewardCard img={img} title={title} discount={discount} />
            </CardWrapper>
          </SwiperSlide>
        ))}
      </Swiper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  .swiper {
    border-radius: 40px;
    padding: 10px 30px 60px 30px;
    overflow: visible;
    @media (${theme.md}) {
    }
  }
  .swiper-wrapper {
    transition-timing-function: linear;
  }
  .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal {
    display: flex;
    gap: 24px;
    margin: 0 auto;
    justify-content: center;
  }
  .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    opacity: 1;
    background: #858585;
  }
  .swiper-pagination-bullet-active {
    background: ${theme.CTAcolor};
  }

  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    /* background: #fff; */

    /* Center slide text vertically */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .swiper-slide {
    width: auto;
    transition: all 0.3s;
    transform: rotate(6deg) scale(1);

    &:hover {
      transform: rotate(0deg) scale(1.05);
    }
  }
`
const CardWrapper = styled.a`
  width: 300px;
  @media (${theme.md}) {
    width: 230px;
  }
`
